import React, { useCallback } from 'react'
import { FormFields, GroupedTagSelector } from '../../components'

const FilterRightPanel = ({ fields, tagSelectorOptions = {}, value, onChange, withSearch, searchIndex, fieldsToRemoveSearch, title }) => {

    const handleChanges = useCallback((changedData) => {
        onChange && onChange(changedData)
    }, [onChange])

    return (
        <div className='filters'>
            {fields.map(fieldData => (
                <FormFields
                    key={fieldData.fieldName}
                    fieldName={fieldData.fieldName}
                    label={fieldData.label}
                    type={fieldData.type}
                    options={fieldData?.options}
                    validations={fieldData?.validations}
                    placeholder={fieldData.placeholder}
                    onChange={fieldData.type === 'chips'
                        ? ((newSelectedIds) => handleChanges({ [fieldData.fieldName]: newSelectedIds }))
                        : handleChanges}
                    value={value[fieldData.fieldName]}
                />
            ))}

            <GroupedTagSelector
                data={tagSelectorOptions}
                value={value}
                onChange={handleChanges}
                withSearch={withSearch}
                searchIndex={searchIndex}
                fieldsToRemoveSearch={fieldsToRemoveSearch}
                searchPlaceholder='Search filter attribute'
                withHr={!!fields.length}
                title={title}
            />
        </div>
    )
}

export default FilterRightPanel